import uuidv4 from './uuid';
import SafeSessionStorage from './storage/SafeSessionStorage';
var STORAGE_KEY = 'tab.id';
var TabTracking = /** @class */ (function () {
    function TabTracking() {
        var _this = this;
        this._generateNewTabId = function () {
            var newTabId = uuidv4();
            _this._safeSessionStorage.setItem(STORAGE_KEY, newTabId);
            return newTabId;
        };
        this._safeSessionStorage = new SafeSessionStorage();
    }
    TabTracking.prototype.getCurrentTabId = function () {
        var tabId = this._safeSessionStorage.getItem(STORAGE_KEY);
        if (!tabId) {
            tabId = this._generateNewTabId();
        }
        return tabId;
    };
    return TabTracking;
}());
export default TabTracking;
